import Styles from "./TopUp.module.scss";
import clsx from "clsx";
import PaginationComponent from "../../../Share/Component/Pagination";
import TableComponent from "../../../Share/Component/Table";
import {
  TOP_UP_ACTIONS,
  TOP_UP_METHODS,
  TOP_UP_STATUSES,
  TOP_UP_TABLE_COLUMNS,
} from "../../../Constants/topUp";
import { formatDate, formatNumber } from "../../../Utils/index";
import { useTopUpPage } from "../../../Hooks/useTopUpPage";

function AdminTopUp() {
  const {
    topUps,
    search,
    fromDate,
    toDate,
    paging,
    getListTopUps,
    setSearch,
    handleFromDateChange,
    handleToDateChange,
  } = useTopUpPage();

  const getMethodBadgeClass = (value) => {
    if (value === TOP_UP_METHODS.BANK || value === TOP_UP_METHODS.TRANSFER)
      return Styles.methodBank;
    if (value === TOP_UP_METHODS.CARD) return Styles.methodCard;
    return Styles.methodWallet;
  };

  const getStatusBadgeClass = (value) => {
    if (value === TOP_UP_STATUSES.COMPLETED) return Styles.statusCompleted;
    if (value === TOP_UP_STATUSES.PENDING) return Styles.statusPending;
    return Styles.statusFailed;
  };

  const getActionBadgeClass = (value) => {
    if (value === TOP_UP_ACTIONS.APPROVE) return Styles.actionApprove;
    if (value === TOP_UP_ACTIONS.REJECT) return Styles.actionReject;
    return Styles.actionReview;
  };

  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
        <div className={clsx(Styles.bodyMainTop)}>
          <div className={clsx(Styles.filterWrap)}>
            <div className={clsx(Styles.searchWrap)}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className={clsx(Styles.Search)}
              />
              <span
                onClick={() => getListTopUps(0)}
                className={clsx(Styles.contentSearch)}
              >
                Search
              </span>
            </div>
            <div className={clsx(Styles.dateFilterWrap)}>
              <input
                type="date"
                title="Từ ngày"
                value={fromDate}
                max={toDate || undefined}
                onChange={(e) => handleFromDateChange(e.target.value)}
                className={clsx(Styles.dateInput)}
              />
              <span className={clsx(Styles.dateSeparator)}>~</span>
              <input
                type="date"
                title="Đến ngày"
                value={toDate}
                min={fromDate || undefined}
                onChange={(e) => handleToDateChange(e.target.value)}
                className={clsx(Styles.dateInput)}
              />
            </div>
          </div>
        </div>
        <div className={clsx(Styles.table)} id="style-3">
          <TableComponent
            data={topUps}
            header={TOP_UP_TABLE_COLUMNS}
            customFormatters={{
              Method: (value) => (
                <span
                  className={clsx(Styles.statusBadge, getMethodBadgeClass(value))}
                >
                  {value}
                </span>
              ),
              Amount: (value) =>
                value == null || value === "" ? "" : formatNumber(value),
              Code: (value) => value || "",
              Status: (value) => (
                <span
                  className={clsx(Styles.statusBadge, getStatusBadgeClass(value))}
                >
                  {value}
                </span>
              ),
              Action: (value) => (
                <span
                  className={clsx(Styles.statusBadge, getActionBadgeClass(value))}
                >
                  {value}
                </span>
              ),
              CreatedDate: (value) => (value ? formatDate(value) : ""),
            }}
          />
        </div>
        <div className={clsx(Styles.footer)}>
          <div className={clsx(Styles.footerWrap)}>
            <PaginationComponent
              page={paging}
              handleCallApi={getListTopUps}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminTopUp;
